import React from "react";
import { Tabs } from "@mantine/core";

const MantineTab = (props:any) => {
    const { variant, defaultValue, children, classNames, onChange, style } = props;

    return (
        <Tabs variant={variant} defaultValue={defaultValue} classNames={classNames} onChange={onChange} style={style}>
            {children}
        </Tabs>
    );
};

const MantineTabList = ({ children, classNameTabList }:any) => {
    return (
        <Tabs.List grow classNames={classNameTabList}>
            {children}
        </Tabs.List>
    );
};

const MantineTabsTab = ({ children, value, leftSection, classNameTabsTab, onClick }:any) => {
    return (
        <Tabs.Tab value={value} leftSection={leftSection} classNames={classNameTabsTab} onClick={onClick}>
            {children}
        </Tabs.Tab>
    );
};

export { MantineTab, MantineTabList, MantineTabsTab };

// Define Tailwind CSS classes for active tabs

